import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import ProgressCircle from 'contest/components/progress-circle';

export default class ScoreSummary extends React.Component {
    render() {
        return (
            <div
                className={`score-summary ${this.props.nextElement
                    ? ' score-summary--linked'
                    : ''}`}
            >
                <div className="score-summary__title">
                    <FormattedHTMLMessage id="brief_score_title" />
                </div>

                {this.renderSummary()}
                {this.renderNextElementLink()}
            </div>
        );
    }

    renderSummary() {
        return (
            <div className="score-summary__content">
                <div className="score-summary__score">
                    <ProgressCircle percentage={this.props.score} />
                </div>
                <div className="score-summary__suggestion">{this.renderNextElement()}</div>
                <div className="score-summary__link-icon">
                    <span className="icon icon--right-2" />
                </div>
            </div>
        );
    }

    renderNextElement() {
        if (this.props.nextElement) {
            return this.selectBestSuggestionForElement();
        } else {
            return <FormattedMessage id="brief_score_all_done" />;
        }
    }

    renderNextElementLink() {
        if (this.props.nextElement) {
            return (
                <a
                    href={`#element-${this.props.nextElement.sectionKey}-${this.props.nextElement
                        .elementKey}`}
                    className="score-summary--link"
                />
            );
        }
    }

    selectBestSuggestionForElement() {
        const title = this.props.nextElement.title;

        switch (this.props.nextElement.type) {
            case 'text':
            case 'textarea':
                return (
                    <FormattedHTMLMessage
                        id="brief_score_improve_text"
                        values={{ element: title }}
                    />
                );

            case 'choice':
            case 'choiceOther':
            case 'imageChoiceOther':
            case 'multipleChoiceOther':
            case 'multipleChoiceImage':
                return (
                    <FormattedHTMLMessage
                        id="brief_score_improve_choices"
                        values={{ element: title }}
                    />
                );

            case 'files':
                return (
                    <FormattedHTMLMessage
                        id="brief_score_improve_files"
                        values={{ element: title }}
                    />
                );

            default:
                return (
                    <FormattedHTMLMessage
                        id="brief_score_improve_generic"
                        values={{ element: title }}
                    />
                );
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.score !== nextProps.score;
    }
}

ScoreSummary.propTypes = {
    score: PropTypes.number.isRequired,
    nextElement: PropTypes.shape({
        sectionKey: PropTypes.string.isRequired,
        elementKey: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }),
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/score-summary.jsx